import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import {
  Table,
  Tbody,
  Tr,
  Td,
  Th,
  Thead,
  TableContainer,
  Text,
} from "@chakra-ui/react";

const Print_classAsssign = forwardRef(({ classData }, ref) => {
  const printRef = useRef();

  useImperativeHandle(ref, () => ({
    handlePrint,
  }));
  const schoolName = sessionStorage.getItem("school_name");
  const schoolEmail = sessionStorage.getItem("school_email");
  const schoolAddress = sessionStorage.getItem("school_address");
  const schoolImage = sessionStorage.getItem("school_image_url");

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`<div>${content}</div>`);
    iframeDoc.close();

    // Wait for the image to load before printing
    const images = iframeDoc.getElementsByTagName("img");
    const loadPromises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve; // Resolve on error to prevent blocking
        })
    );

    Promise.all(loadPromises).then(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    });
  };

  return (
    <div
      ref={printRef}
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.5",
      }}
    >
      {/* Header with Logo */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "40px",
          borderBottom: "1px solid #e5e5e5",
          paddingBottom: "20px",
          gap: "24px",
        }}
      >
        <img
          src={schoolImage ? `${schoolImage}` : ""}
          alt={`school Logo`}
          style={{
            width: "70px",
            height: "70px",
            objectFit: "contain",
            backgroundColor: "#fff",
            padding: "10px",
          }}
        />

        <div>
          <h1
            style={{
              margin: "0",
              fontSize: "20px",
              fontWeight: "600",
              color: "#1a1a1a",
              fontFamily: "'Times New Roman', serif",
              letterSpacing: "0.5px",
            }}
          >
            {schoolName}
          </h1>
          <h2
            style={{
              margin: "6px 0 0",
              fontSize: "18px",
              fontWeight: "500",
              color: "#666",
              fontFamily: "'Times New Roman', serif",
            }}
          >
            {schoolAddress}
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: "#6C757D",
              margin: "6px 0 0",
              fontFamily: "Arial, sans-serif",
            }}
          >
            {schoolEmail}
          </p>
        </div>
      </div>
      <h3>Class-Assign to Teachers List</h3>
      {/* Table with Class Data */}
      <TableContainer>
        <Table
          sx={{
            "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
          }}
          style={{
            border: "1px solid #d4c2c2",
            borderCollapse: "collapse",
            width: "100%",
          }}
        >
          <Thead>
            <Tr>
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Serial No.
              </Th>
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Class Name
              </Th>
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Division
              </Th>
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Section
              </Th>
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Min No
              </Th>
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Max No
              </Th>

              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Assigned Teacher
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {classData.map((classItem, index) => (
              <Tr key={index}>
                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {index + 1}
                </Td>
                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {classItem.class}
                </Td>
                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {classItem.division}
                </Td>
                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {classItem.section}
                </Td>
                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {classItem.min_students}
                </Td>
                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {classItem.max_students}
                </Td>

                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {classItem.name}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </div>
  );
});

export default Print_classAsssign;
